import Controller from '../inline_edit_controller'
export default Controller